import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PASS_AMC_INFORMATION_STORE_NAME, PassAmcInformationState } from './pass-amc-information.state';

/** Select PassengerAmcInformation State */
export const selectPassengerAmcInformationState = createFeatureSelector<PassAmcInformationState>(
  PASS_AMC_INFORMATION_STORE_NAME
);

/** Select PassengerAmcInformation isPending status */
export const selectPassengerAmcInformationIsPendingStatus = createSelector(
  selectPassengerAmcInformationState,
  (state) => !!state.isPending
);

/** Select PassengerAmcInformation isFailure status */
export const selectPassengerAmcInformationIsFailureStatus = createSelector(
  selectPassengerAmcInformationState,
  (state) => !!state.isFailure
);
